module.exports = __webpack_public_path__ + "static/media/classting-logo.b77cf499.svg";